import styled from '@emotion/styled';

import { ContentPanel, ContentPanelInner } from '@/components/common/Panel/style';
import { pageSectionLayout } from '@/styles/pageLayout';

export const Container = styled.div`
	${pageSectionLayout}
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.scale.space2xl};
`;

export const SectionCard = styled(ContentPanel)``;

export const CardBody = styled(ContentPanelInner)`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.scale.spaceLg};
`;

export const SectionHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.scale.spaceSm};
`;

export const ContentTitle = styled.h2`
	margin: 0;
	font-size: ${({ theme }) => theme.fontSize.sizeXl};
	font-weight: ${({ theme }) => theme.fontWeight.weightBold};
	line-height: 1.3;
	letter-spacing: ${({ theme }) => theme.ui.letterSpacing.tight};
	color: ${({ theme }) => theme.ui.text.primary};
`;

export const SectionTitle = styled.h3`
	margin: 0;
	font-size: ${({ theme }) => theme.fontSize.sizeLg};
	font-weight: ${({ theme }) => theme.fontWeight.weightBold};
	line-height: 1.35;
	letter-spacing: ${({ theme }) => theme.ui.letterSpacing.tight};
	color: ${({ theme }) => theme.ui.text.primary};
`;

export const LeadBox = styled.div`
	padding: ${({ theme }) => theme.scale.spaceMd} ${({ theme }) => theme.scale.spaceLg};
	border-radius: ${({ theme }) => theme.effects.radiusMd};
	background: ${({ theme }) => theme.colors.primary50};
	border: 1px solid ${({ theme }) => theme.colors.primary100};
`;

export const LeadText = styled.p`
	margin: 0;
	font-size: ${({ theme }) => theme.fontSize.sizeMd};
	font-weight: ${({ theme }) => theme.fontWeight.weightMedium};
	line-height: 1.55;
	color: ${({ theme }) => theme.ui.text.primary};
	word-break: keep-all;

	& + & {
		margin-top: 0.4rem;
	}
`;

export const LeadHint = styled.p`
	margin: 0.6rem 0 0;
	font-size: ${({ theme }) => theme.fontSize.sizeSm};
	font-weight: ${({ theme }) => theme.fontWeight.weightRegular};
	line-height: 1.5;
	color: ${({ theme }) => theme.ui.text.secondary};
`;

export const NoticeList = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
	margin: 0;
	padding: ${({ theme }) => theme.scale.spaceMd} ${({ theme }) => theme.scale.spaceLg};
	list-style: none;
	border-radius: ${({ theme }) => theme.effects.radiusMd};
	background: ${({ theme }) => theme.ui.surface.subtle};
	border: 1px solid ${({ theme }) => theme.ui.border.default};
`;

export const NoticeItem = styled.li`
	position: relative;
	padding-left: 1.2rem;
	font-size: ${({ theme }) => theme.fontSize.sizeMd};
	font-weight: ${({ theme }) => theme.fontWeight.weightRegular};
	line-height: 1.5;
	color: ${({ theme }) => theme.ui.text.secondary};
	word-break: keep-all;

	&::before {
		content: '';
		position: absolute;
		top: 0.65em;
		left: 0;
		width: 0.4rem;
		height: 0.4rem;
		border-radius: 50%;
		background: ${({ theme }) => theme.ui.interactive.primary};
	}
`;

export const ManuscriptPreview = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
	padding: ${({ theme }) => theme.scale.spaceLg};
	border-radius: ${({ theme }) => theme.effects.radiusMd};
	background: ${({ theme }) => theme.ui.surface.subtle};
	border: 1px solid ${({ theme }) => theme.ui.border.default};
`;

export const GuideLine = styled.p`
	margin: 0;
	width: 100%;
	color: ${({ theme }) => theme.ui.text.primary};
	font-size: ${({ theme }) => theme.fontSize.sizeMd};
	font-weight: ${({ theme }) => theme.fontWeight.weightMedium};
	line-height: 1.65;
	letter-spacing: ${({ theme }) => theme.ui.letterSpacing.body};
	white-space: pre-line;
	text-align: left;
	word-break: keep-all;

	&.title {
		font-size: ${({ theme }) => theme.fontSize.sizeLg};
		font-weight: ${({ theme }) => theme.fontWeight.weightBold};
		line-height: 1.45;
		color: ${({ theme }) => theme.ui.interactive.primary};
	}

	&.subtitle {
		font-size: ${({ theme }) => theme.fontSize.sizeMd};
		font-weight: ${({ theme }) => theme.fontWeight.weightBold};
		color: ${({ theme }) => theme.ui.text.secondary};
	}

	&.note {
		font-size: ${({ theme }) => theme.fontSize.sizeSm};
		font-weight: ${({ theme }) => theme.fontWeight.weightSemi};
		color: ${({ theme }) => theme.colors.red600};
	}

	&.small {
		font-size: ${({ theme }) => theme.fontSize.sizeSm};
		font-weight: ${({ theme }) => theme.fontWeight.weightRegular};
		line-height: 1.6;
		color: ${({ theme }) => theme.ui.text.secondary};
	}

	&.spacer {
		height: 1.2rem;
		font-size: 0;
		line-height: 0;
	}
`;

export const DownloadGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: ${({ theme }) => theme.scale.spaceSm};

	& > a {
		width: 100%;
		min-height: 5.2rem;
	}

	@media screen and (max-width: 640px) {
		grid-template-columns: 1fr;
	}
`;
